<style>
  table {
    width: 100%; /* Make the table take full width of its container */
    border-collapse: collapse; /* Ensures borders touch */
  }
  tr td {
    width: 50%; /* Each column gets 50% of the table width */
    padding: 0 10px; /* Add some padding for readability */
  }
  .pl-8 {
    padding-left: 8px;
  }
  .pl-16 {
    padding-left: 16px;
  }
  .text-justify {
    text-align: justify;
  }
</style>
<div class="pdf-page app-cp-02-99-06-07" id="cp990607">
  <h3 style="display: flex; justify-content: end">
    <b>COMMERCIAL PROPERTY</b>
  </h3>
  <h3 style="display: flex; justify-content: end"><b>CP 02 99 06 07</b></h3>
  <div>
    <h3 class="font-medium" style="text-align: center">
      <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ IT CAREFULLY.</b>
    </h3>
    <br />
    <h3 class="font-large" style="text-align: center">
      <b>CANCELLATION CHANGES</b>
    </h3>
    <br />
  </div>
  <div>
    <p class="font-small">
      This endorsement modifies insurance provided under the following:
    </p>
    <div class="pl-16 font-small">
      <p class="text-justify font-small">
        COMMERCIAL PROPERTY COVERAGE PART <br />STANDARD PROPERTY POLICY
      </p>
    </div>
    <br />
  </div>
  <table style="width: 100%; margin: 0 auto; border-spacing: 20px 0">
    <thead>
      <tr>
        <th></th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="vertical-align: top;">
          <p class="text-justify font-small">
            The following is added to the <b>Cancellation</b> Common Policy
            Condition:<br /><br />
            If any one of the following conditions exists at any building that
            is Covered Property in this policy, we may cancel this Coverage Part
            by mailing or delivering to the first Named Insured written notice
            of cancellation at least five days before the effective date of
            cancellation.
          </p>
          <p class="font-small">
            <b>A.</b
            ><span class="pl-8 font-small"
              >The building has been vacant or unoccupied 60 or more consecutive
              days. This does not apply to:</span
            >
          </p>
          <div class="font-small" class="pl-16">
            <p class="text-justify">
              <b>1.</b
              ><span class="pl-8 font-small">Seasonal unoccupancy;</span>
            </p>
            <p class="text-justify">
              <b>2.</b
              ><span class="pl-8 font-small"
                >Buildings in the course of construction, renovation or
                addition; or</span
              >
            </p>
            <p class="text-justify">
              <b>3.</b
              ><span class="pl-8 font-small"
                >Buildings to which the Vacancy Permit endorsement
                applies.</span
              >
            </p>
            <p class="text-justify font-small">
              Buildings with 65% or more of the rental units or floor area
              vacant or unoccupied are considered unoccupied under this
              provision.
            </p>
          </div>
          <p class="font-small">
            <b>B.</b
            ><span class="pl-8 font-small"
              >After damage by a covered cause of loss, permanent repairs to the
              building:</span
            >
          </p>
          <div class="font-small" class="pl-16">
            <p class="text-justify font-small">
              <b>1.</b
              ><span class="pl-8 font-small">Have not started; and</span>
            </p>
            <p class="text-justify font-small">
              <b>2.</b
              ><span class="pl-8 font-small"
                >Have not been contracted for, within 30 days of initial payment
                of loss.</span
              >
            </p>
          </div>
        </td>
        <td style="vertical-align: top">
          <p
            class="font-small"
            style="margin-bottom: 0; padding-bottom: 0;"
          >
            <b>C.</b><span class="pl-8 font-small">The building has:</span>
          </p>
          <ol style="list-style: none; counter-reset: item">
            <li style="counter-increment: item" class="text-justify font-small">
              <b>1.</b
              ><span class="pl-8 font-small"
                >An outstanding order to vacate;</span
              >
            </li>
            <li style="counter-increment: item" class="text-justify font-small">
              <b>2.</b
              ><span class="pl-8 font-small"
                >An outstanding demolition order;</span
              >
            </li>
            <li style="counter-increment: item" class="text-justify font-small">
              <b>3.</b
              ><span class="pl-8 font-small"
                >Been declared unsafe by governmental authority.</span
              >
            </li>
          </ol>
          <p class="text-justify font-small">
            <b>D.</b>
            <span class="pl-8 font-small"
              >Fixed and salvageable items have been or are being removed from
              the building and are not being replaced. This does not apply to
              such removal that is necessary or incidental to any renovation or
              remodeling</span
            >
          </p>
          <p class="text-justify font-small">
            <b>E.</b><span class="pl-8 font-small"> Failure to:</span>
          </p>
          <ol style="list-style: none; counter-reset: item">
            <li style="counter-increment: item" class="text-justify font-small">
              <b>1.</b
              ><span class="pl-8 font-small"
                >Furnish necessary heat, water, sewer service or electricity for
                30 consecutive days or more, except during a period of seasonal
                unoccupancy; or</span
              >
            </li>
            <li style="counter-increment: item" class="text-justify font-small">
              <b>2.</b><span class="pl-8 font-small"></span>Pay property taxes
              that are owing and have been outstanding for more than one year
              following the date due, except that this provision will not apply
              where you are in a bona fide dispute with the taxing authority
              regarding payment of such taxes
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>
